import styled from 'styled-components';
import {Button} from 'global/styles/styles.js';

const S = {};

S.RegisterWizardForm = styled.div`
  padding: 1.5rem 1rem 1rem;
  height: 100%;
  background-color: #fff;
`;

S.RegisterWizardFormTitle = styled.h2`
  color: rgba(0, 0, 0, 0.87);
  text-align: center;
  font-size: 1.65rem;
  padding-top: 1.1875rem;
  font-weight: 400;
`;

S.StepsLineWrapper = styled.div`
  margin-top: 1rem;

  & .stepsContainer {
    display: flex;
    justify-content: center;
    padding: 1rem 0;

    &.stepTwoActive {
      .step {
        background-color: ${({theme: {$registerFormStepActiveBgColor}}) => $registerFormStepActiveBgColor};
        color: #fff;
        border: none;

        & .stepTitle {
          color: #C62828;
        }
     }

      .separator {
          &:after {
            border-bottom: 1px solid #D32F2F;
          }
      }

       & + .stepsTitles div {
        color: #D32F2F;
        font-weight: 500;
      }
    }

    &.stepOneActive {

      & + .stepsTitles > div:first-child {
       color: #D32F2F;
       font-weight: 500;
     }

     .stepOne {
        background-color: ${({theme: {$registerFormStepActiveBgColor}}) => $registerFormStepActiveBgColor};
        color: #fff;
        border: none;

        & .stepTitle {
          color: #C62828;
        }
     }
   }
  }

  & .stepsTitles {
    display: flex;
    justify-content: space-evenly;

    & div {
      font-size: .75rem;
      color: rgba(0, 0, 0, 0.24);
    }
  }

  & .step {
    display: flex;
    flex-direction: column;
    border-radius: 50%;
    height: 26px;
    width: 26px;
    color: rgba(0, 0, 0, 0.24);
    background-color: ${({theme: {$registerFormStepBgColor}}) => $registerFormStepBgColor};
    border: 1px solid rgba(0, 0, 0, 0.24);
    align-items: center;
    justify-content: center;

    & .stepNumber {
        font-weight: 400;
        font-size: 0.75rem;
    }
  }

  & .separator {
    width: 100px;
    position: relative;
    height: 100%;
    align-self: center;
      &:after {
        content: "";
        display: block;
        border-bottom: 1px solid rgba(0, 0, 0, 0.24);
      }
  }
`;

S.ConfirmationModal = styled.div`
   display: flex;
   flex-direction: column;
   flex: 1;
`;

S.ConfirmationMsg = styled.div`
  font-weight: 600;
  padding: .7rem;
`;

S.ConfirmationCloseBtn = styled(Button)`
    display: block;
    background-color: ${({theme: {$registerFormConfirmationCloseBtnBgColor}}) => $registerFormConfirmationCloseBtnBgColor};
    height: 2.625rem;
    font-size: .75rem;
    font-weight: 500;
    padding: 0;
    width: 50%;
    margin: 1.5rem 0;
    color: #fff;
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto; 
`;

S.HideIframe = styled.iframe`
    display: none;
`;

S.BellIcon = styled.div`
    width: 30px;
    height: 30px;
    margin: 0 auto;
     & svg {
       width: 100%;
        & .a {
            fill: #c62828 !important;
        }
    }
`;

S.ModalText = styled.div`
    padding-bottom: 1.25rem;
    padding-top: 0.625rem;
    font-size: 0.8125rem;
    padding: 0.625rem 2.5rem 1.25rem;
    line-height: 1.6;
    text-align: center;
`;

S.Modal = styled.div`
    z-index: 98;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .confirm-modal-content {
        position: relative;
        z-index: 99;
        top: -110px;
        width: calc(90% - 32px);
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.26) 0px 19px 38px;
        border-radius: 2px;
        padding: 20px 16px;
        height: auto;

        .buttonsWrapper {
            display: flex;
            justify-content: space-between;  
        }
    }
`;
 
S.ModalButton = styled.button`
    width: 8.875rem;
    height: 2.625rem;
    box-sizing: border-box;
    padding: 0;
    border-radius: 3px;
    border: ${props => props.cancel ? "1px solid #C62828" : "none"};
    color: ${props => props.cancel ? "#C62828" : "#fff"};
    background-color: ${props => props.cancel ? "#fff" : "#C62828"};  
`;


export default S;